<template>
  <b-card class="no-border mt-3" no-body>
    <location-table />
  </b-card>
</template>
<script>
import LocationTable from '@/components/shipment_md/LocationTable.vue';

export default {
  name: 'location_list',
  components: {
    LocationTable,
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'locations', name: 'Locations' },
    ]);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/shipment_md/locations/List.vue